<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="title header-tablepage">Print Non-Serial</h4>
      <div class="d-flex align-items-center">
        <p
          class="text-link text-gray text-underline mb-0 mr-2"
          @click="clearAll()"
        >
          Clear
        </p>

        <!-- <b-dropdown id="dropdown" right class="btn-mobile mr-2">
          <template #button-content>
            <span class="d-none d-md-inline-flex btn-text mr-1">Action</span>
          </template>

          <b-dropdown-item @click="openModalProductList(1)">
            สินค้า
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(2)">
            เอกสารรับเข้า STK
          </b-dropdown-item>

          <b-dropdown-item @click="openModalProductList(4)">
            เอกสาร Inventory Transfer
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(5)">
            เอกสาร Repair
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(6)">
            เอกสาร CN
          </b-dropdown-item>
        </b-dropdown> -->
        <b-button class="btn-filter mr-2" @click="openModalProductList(1)">
          <font-awesome-icon icon="plus" />
          สินค้า</b-button
        >
        <b-button class="btn-filter" @click="openModalPrint()">
          <font-awesome-icon icon="print" />
          Print</b-button
        >
      </div>
    </div>
    <div class="bg-white border-red p-3">
      <b-table
        striped
        responsive
        hover
        :busy="isBusy"
        :items="items"
        :fields="fields"
        class="table-main table-custom"
        show-empty
        empty-text="No matching barcode found"
      >
        <template #cell(weight)="{ item }">
          <div v-if="item.weight">{{ item.weight | numeral("0,0.00") }} </div>
          <div v-else>-</div>
        </template>
        <template #cell(product_brand_name)="{ item }">
          {{ item.product_brand_name || "-" }} บาท
        </template>
        <template #cell(product_model_name)="{ item }">
          {{ item.product_model_name || "-" }}
        </template>

        <template #cell(product_model_code)="{ item }">
          {{ item.product_model_code || "-" }}
        </template>

        <template #cell(action)="{ item }">
          <font-awesome-icon
            icon="trash-alt"
            class="pointer text-danger"
            @click="deleteItem(item.id)"
          />
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTake"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />
    </div>
    <ModalConfirm
      ref="confirmModal"
      :text="confirmMsg"
      @handler="confirmDelete"
    />
    <ModalProductList
      ref="modalProductList"
      @success="getList(1)"
    />
    <ModalPrint ref="modalPrint" />
    <ModalProcess ref="modalProcess" />
  </div>
</template>
<script>
import ModalConfirm from "@/components/modal/ModalConfirm.vue";
import ModalProductList from "./components/ModalProductList.vue";
import ModalPrint from "./components/ModalPrint.vue";
import ModalProcess from "./components/ModalProcess.vue";
import { valHooks } from "jquery";

export default {
  props: {},
  components: { ModalConfirm, ModalProductList, ModalPrint, ModalProcess },
  name: "Inventory",
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "index", label: "ลำดับ" },
        { key: "barcode", label: "รหัสสินค้า" },
        { key: "product_model_code", label: "Model Status" },
        { key: "name", label: "Name" },
        { key: "product_brand_name", label: "Product Brand" },
        { key: "product_model_name", label: "Product Model" },

        { key: "action", label: "Action" },
      ],
      items: [],
      filter: {
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        page: 1,
        take: 10,
        search: "",
      },
      rows: 0,
      deleteId: null,
      confirmMsg: "",

    };
  },
  async created() {

    await this.getList();
  },
  methods: {
    async getList(isUpdate) {
      this.isBusy = true;
      if (isUpdate) {
        await this.axios(`NonSerialProduct/UpdateJson`);
        await new Promise((resolve) => setTimeout(resolve, 3000));

        const payload = { ...this.filter };
        const res = await this.axios.post(`/NonSerialProduct/get`, payload);

        this.rows = res.data.detail.total_count;
        this.items = res.data.detail.detail.map((x, index) => ({
          ...x,
          index: index + 1 + this.filter.take * (this.filter.page - 1),
        }));

        await this.$bus.$emit("hideLoading");
        this.isBusy = false;
        return;
      }

      const payload = { ...this.filter };
      const res = await this.axios.post(`/NonSerialProduct/Get`, payload);

      this.rows = res.data.detail.total_count;
      this.items = res.data.detail.detail.map((x, index) => ({
        ...x,
        index: index + 1 + this.filter.take * (this.filter.page - 1),
      }));

      await this.$bus.$emit("hideLoading");

      this.isBusy = false;
    },

    async handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      await this.getList();
    },
    pagination(page) {
      this.filter.page = page;
      this.getList();
    },
    deleteItem(id) {
      this.confirmMsg = "Confirm Deletion?";
      this.$refs.confirmModal.show("delete");

      this.deleteId = id;
    },
    async confirmDelete(val, type) {
      if (val && this.deleteId && type === "delete") {
        console.log(val, type);
        this.$bus.$emit("showLoading");
        const res = await this.axios.delete(
          `/NonSerialProduct/DeleteById/${this.deleteId}/${this.filter.user_guid}`
        );
        if (res.data.result) {
          await this.axios(`NonSerialProduct/UpdateJson`);

          this.filter = {
            user_guid: this.$cookies.get("print_tag_admin_user_guid"),
            page: 1,
            take: 10,
            search: "",
          };
          this.deleteId = null;
          this.$bus.$emit("hideLoading");
          await this.getList();
        }
      } else if (val && type === "clear") {
        this.$bus.$emit("showLoading");

        const res = await this.axios.delete(
          `/NonSerialProduct/clear/${this.filter.user_guid}`
        );
        await this.axios(`NonSerialProduct/UpdateJson`);

        this.filter = {
          user_guid: this.$cookies.get("print_tag_admin_user_guid"),
          page: 1,
          take: 10,
          search: "",
        };
        this.$bus.$emit("hideLoading");
        await this.getList();
      }
    },
    openModalProductList(type) {
      this.$refs.modalProductList.show(type);
    },
    openModalPrint() {
      this.$refs.modalPrint.show();
    },
    async clearAll() {
      this.confirmMsg = "Confirm Deletion?";
      this.$refs.confirmModal.show("clear");
    },
  },
};
</script>
<style lang="scss" scoped></style>
